'use strict';

var React = require('react'),
    _ = require('underscore'),
    Link = require('../atoms/Link'),
    UserLink = require('../atoms/UserLink'),
    Icon = require('../atoms/Icon'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ServiceTypes = require('../constants/ServiceTypes'),
    formatDate = require('../utils/formatDate'),
    UserStore = require('../stores/UserStore');

require('./InviteList.less');

var InviteList = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    invites: React.PropTypes.arrayOf(
      React.PropTypes.shape({
        id: React.PropTypes.number.isRequired,
        serviceType: React.PropTypes.oneOf([ServiceTypes.FACEBOOK, ServiceTypes.EMAIL]).isRequired,
        serviceId: React.PropTypes.string.isRequired,
        created: React.PropTypes.string.isRequired,
        joined: React.PropTypes.string,
        user: React.PropTypes.number.isRequired,
      }).isRequired
    ).isRequired,
    reInvited: React.PropTypes.object.isRequired,
    onResendClick: React.PropTypes.func.isRequired
  },

  render: function () {
    var invites = _.map(this.props.invites, this.renderInvite);

    return (
      <ul className='InviteList'>
        {invites}
      </ul>
    );
  },

  renderInvite: function (invite) {
    var serviceType = invite.serviceType,
        user = UserStore.get(invite.user),
        description;

    if (serviceType === ServiceTypes.EMAIL) {
      description = invite.serviceId;
    } else {
      description = user.name;
    }

    return (
      <li className='InviteList-item'
          key={invite.id}>

        <div className='InviteList-user'>
          <div className='InviteList-name'>
            <Icon name={serviceType.toLowerCase()} size='xsmall' mode={serviceType === ServiceTypes.EMAIL ? 'stroke' : 'fill'} />
            {description}
          </div>
          <div className='InviteList-date'>
            Invited {formatDate(invite.created)}
          </div>
        </div>

        <div className='InviteList-status'>
          {invite.joined !== null &&
            <div className='InviteList-user'>
              <div className='InviteList-name'>
                <UserLink user={user}
                          target='_blank' />
              </div>
              <div className='InviteList-date'>
                Joined {formatDate(invite.joined)}
              </div>
            </div>
          }

          {invite.joined === null &&
            <div>
              <b className='InviteList-pending'>Pending</b>

              {this.props.reInvited[invite.id] !== true &&
                <Link className='InviteList-resend' onClick={this.handleResendClick.bind(this, invite)}>
                  (Resend)
                </Link>
              }
            </div>
          }
        </div>
      </li>
    );
  },

  handleResendClick: function (invite) {
    this.props.onResendClick(invite);
  }
});

module.exports = InviteList;


/** WEBPACK FOOTER **
 ** ./organisms/InviteList.jsx
 **/